import { MenuItem, MenuItemProps, Tooltip } from '@mui/material';
import { useHasAccess } from '../../payWall/RevenueCatProvider';
import { Link } from 'react-admin';
import { ColorScheme, getColorGradient } from '../../models/color-scheme';
import { PaidFeatureIcon } from '../pay-wall/PaidFeatureIcon';
import { MembershipType } from '../../payWall/paywall.model';


export const colorSchemeItem = (colorScheme: ColorScheme, colorSchemeReverse: boolean) => {

  return (
    <Tooltip title={colorScheme.name} placement='top-start'>
      <div
        style={{
          width: 220,
          height: 20,
          background: getColorGradient(colorScheme, colorSchemeReverse),
          borderRadius: 1,
          border: '1px solid #ccc',
        }}
        aria-label={colorScheme.name}
      />
    </Tooltip>
  );
};

const membershipFromColorSchemeCategoryMap: Record<string, MembershipType> = {
  'Basic': 'Free',
  'Advanced': 'Novice',
  'Expert': 'Pro'
};

type ColorMenuItemProps = MenuItemProps & { colorScheme: ColorScheme; colorSchemeReverse: boolean };

export const ColorMenuItem = ({
  colorScheme,
  colorSchemeReverse,
  ...props
}: ColorMenuItemProps) => {
  const [hasNoviceAccess] = useHasAccess('Novice');
  const [hasProAccess] = useHasAccess('Pro');

  const isAvailable = (
    (colorScheme.category === 'Basic') ||
    (colorScheme.category === 'Advanced' && hasNoviceAccess) ||
    (colorScheme.category === 'Expert' && hasProAccess)
  );
  
  if (!isAvailable) {
    return (
      <MenuItem href component={Link} to='/pricing'>
        <PaidFeatureIcon membership={membershipFromColorSchemeCategoryMap[colorScheme.category]} />
        {colorSchemeItem(colorScheme, colorSchemeReverse)}
      </MenuItem>
    )
  }

  return (
    <MenuItem {...props} sx={{ justifyContent: 'center' }}>
      {colorSchemeItem(colorScheme, colorSchemeReverse)}
    </MenuItem>
  );
};

